import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '@/shared/components/OkCancelModal';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import CheckboxList from '@/shared/components/input/CheckboxList';
import Checkbox from '@/shared/components/input/Checkbox';

const messages = defineMessages({
  SelectAll: 'Select all',
});

class CheckboxListModal extends Component {
  state = {
    items: [],
    selectAll: false,
  };

  reloadItems = () => {
    const { items = [], sortByLabel } = this.props;
    this.setState({
      selectAll: items.every(x => x.selected),
      items: sortByLabel
        ? items
            .map(x => ({
              ...x,
              selected: x.selected || false,
            }))
            .sort(dynamicSort('label'))
        : items.map(x => ({
            ...x,
            selected: x.selected || false,
          })),
    });
  };

  componentDidMount() {
    const { show } = this.props;
    if (show) {
      this.reloadItems();
    }
  }

  componentDidUpdate(prevProps) {
    const { show } = this.props;
    if (!prevProps.show && show) {
      this.reloadItems();
    }
  }

  static propTypes = {
    onSave: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool,
    title: PropTypes.node,
    sortByLabel: PropTypes.bool,
    showSelectAll: PropTypes.bool,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string,
        selected: PropTypes.bool,
      }),
    ).isRequired,
  };

  static defaultProps = {
    show: false,
    title: null,
    sortByLabel: true,
    showSelectAll: true,
  };

  taskStatusChanged = event => {
    const taskStatus = event.target.value;
    this.setState(state => ({
      ...state,
      selectedTaskStatus: taskStatus,
    }));
  };

  onSave = () => {
    const { items } = this.state;
    const { onSave } = this.props;

    return onSave(items);
  };

  closeModal = () => {
    const { onClose } = this.props;
    onClose();
  };
  handleItemChanged = (item, selected) => {
    const { items } = this.state;
    const newItems = items.map(i => {
      if (i.id !== item.id) return i;
      return {
        ...i,
        selected,
      };
    });

    this.setState({
      items: newItems,
      selectAll: selected && newItems.every(x => x.selected),
    });
  };
  handleSelectAll = selected => {
    this.setState(({ items }) => ({
      selectAll: selected,
      items: items.map(i => ({
        ...i,
        selected,
      })),
    }));
  };

  render() {
    const { show, intl, title, showSelectAll } = this.props;
    const { items, selectAll } = this.state;

    return (
      <OkCancelModal title={title} show={show} onClose={this.closeModal} onSave={this.onSave}>
        {show && (
          <div>
            {showSelectAll && (
              <Checkbox
                value={selectAll}
                onClick={this.handleSelectAll}
                text={intl.formatMessage(messages.SelectAll)}
              />
            )}
            <CheckboxList items={items} onItemChanged={this.handleItemChanged} />
          </div>
        )}
      </OkCancelModal>
    );
  }
}

export default injectIntl(CheckboxListModal);
